/* epgCardTitle.tsx */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgCardTitle = styled.div<{ displayContent: boolean }>`
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: ${(props) => (props.displayContent ? 1 : 0)};
`;

export default EpgCardTitle;
